export enum AblyGoodsCardActionType {
  Like = 'LIKE',
  More = 'MORE',
}
